export default {
    'misc.action.next'                          : 'Prochain',
    'misc.action.back'                          : 'Précédent',
    'misc.priceValue'                           : '{price} $',
    'misc.paymentConfirmation.proggressBar'     : 'Transaction en cours',
    'misc.error'                                : 'Une erreur est survenue',
    'misc.beforeUnload'                         : 'Attention! Vous allez partir de cette page et certaines informations peuvent être perdu. Désirez-vous partir de cette page?',
    "misc.select.suggested"                     : "Suggéré",
}